<template>
    <div class="result-summary-bar px-3 py-2 my-1">
        <span class="summary-total">
            <font-awesome-icon icon="list" class="summary-icon" />
            {{ totalCount }} {{ $t('common.pcs')}}
        </span>
        <template v-if="showBreakdown">
            <span class="summary-divider" aria-hidden="true">|</span>
            <span
                v-for="status in selectedStatuses"
                :key="status"
                :class="statusClass(status)"
            >
                {{ getStatusString(status) }}: <strong>{{ statusCounts.get(status) || 0 }}</strong>
            </span>
        </template>
    </div>
</template>

<script>
import {workAssignmentHelper} from '../mixins/WorkAssignmentMixin.js'

export default {
    name: 'WorkAssignmentResultSummary',

    mixins: [workAssignmentHelper],

    props: {
        results: {
            type: Array,
            required: true
        },
        searchParams: {
            type: Object,
            required: true
        },
        isObserver: {
            type: Boolean,
            required: true
        }
    },

    computed: {
        totalCount() {
            return this.results.length
        },

        selectedStatuses() {
            if (this.searchParams?.statuses?.length > 0) {
                return this.searchParams.statuses
            }
            // No filters - all statuses

            return this.getStatus(false).map(item => item.status);
        },

        showBreakdown() {
            return this.isObserver && this.selectedStatuses.length >= 2
        },

        statusCounts() {
            const counts = new Map()
            for (const item of this.results) {
                const current = counts.get(item.status) ?? 0
                counts.set(item.status, current + 1)
            }
            return counts
        }
    }
}
</script>

<style scoped>
.result-summary-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1em 0.75em;
    width: 100%;
    background: #ffffff;
    border: 1px solid #c8e07a;
    border-radius: 0.4em;
    padding: 1em 0.75em;
    margin-top: 0.3em;
    margin-bottom: 0.3em;
    font-size: 0.88em;
    color: #404041;
    box-sizing: border-box;
}

.summary-icon {
    color: #7FC000;
    margin-right: 0.75em;
}

.summary-total {
    white-space: nowrap;
    font-size: 1.2rem;
}

.summary-divider {
    color: #5f8f01;
    font-weight: 300;
    user-select: none;
    margin: 0 1rem;
}

</style>
